export default "__VITE_ASSET__CChDUX40__"